import * as THREE from 'three'

import { type NormalPlane, PlanarUVBuilder } from './planar-uv-builder'

export class UVBuilder {
  private geometry: THREE.Geometry

  constructor(geometry: THREE.Geometry) {
    this.geometry = geometry
  }

  public planar(
    a: number,
    b: number,
    c: number,
    plane: NormalPlane,
    referencePlane: NormalPlane = 'z'
  ) {
    return new PlanarUVBuilder(this.geometry, a, b, c, plane, referencePlane)
  }
}
